import * as React from 'react';

import {
    DataCollectionResource,
    DataCondition,
    DataExportFormat,
    DataFilters,
    DataGranularity,
    DataGranularityKey,
    DataResponse,
    DataToolConfig,
    DataType,
} from '@portal/common/types';

import ChartRefinementFiltersControls from '../ChartRefinementFiltersControls';
import Container from './Container';

type LineChartSectionProps = {
    forecastTimeUnitStart: number | string;
    initialTimeUnitValue: number | string;
    isForecastingData: boolean;
    enableExportPNG: boolean;
    onDataLoad?: () => void;
    conditionsDataTypes: DataType[];
    conditionsDataTypesGranularity: DataGranularity;
    conditions: DataCondition[];
    multipleFilterKeys: DataGranularityKey[];
    mergedChartDataResponses: null | DataResponse;
    isLoadingDataExplorerData: boolean;
    isLoadingChartData: boolean;
    filtersValues: DataFilters;
    baseForecastScenarioId: number;
    observedForecastScenarioId: number;
    timeUnitKey: DataGranularityKey;
    onExportData?: (format: DataExportFormat) => void;
    numberFormatter: (value: number | string) => string;
    dataToolConfig: DataToolConfig;
    selectedDataTool: string;
    selectedDataCollection: DataCollectionResource;
    maxValuesSelectedFilter: DataGranularityKey;
    refinementFilters: DataFilters;
    dataResponse: DataResponse;
    theme?: any;
};

const LineChartSection: React.FC<LineChartSectionProps> = ({
    forecastTimeUnitStart,
    conditions,
    conditionsDataTypes,
    conditionsDataTypesGranularity,
    enableExportPNG,
    onDataLoad,
    isForecastingData,
    isLoadingDataExplorerData,
    isLoadingChartData,
    filtersValues,
    multipleFilterKeys,
    baseForecastScenarioId,
    observedForecastScenarioId,
    timeUnitKey,
    initialTimeUnitValue,
    mergedChartDataResponses,
    onExportData,
    numberFormatter,
    dataToolConfig,
    selectedDataTool,
    selectedDataCollection,
    maxValuesSelectedFilter,
    theme,
    refinementFilters,
    dataResponse,
}) => (
    <>
        <ChartRefinementFiltersControls />
        <Container
            isLoadingData={isLoadingChartData || isLoadingDataExplorerData}
            filtersValues={filtersValues}
            multipleFilterKeys={multipleFilterKeys}
            forecastTimeUnitStart={forecastTimeUnitStart}
            initialTimeUnitValue={initialTimeUnitValue}
            isForecastingData={isForecastingData}
            enableExportPNG={enableExportPNG}
            onDataLoad={onDataLoad}
            conditions={conditions}
            conditionsDataTypes={conditionsDataTypes}
            conditionsDataTypesGranularity={conditionsDataTypesGranularity}
            baseForecastScenarioId={baseForecastScenarioId}
            observedForecastScenarioId={observedForecastScenarioId}
            timeUnitKey={timeUnitKey}
            mergedChartDataResponses={mergedChartDataResponses}
            onExportData={onExportData}
            numberFormatter={numberFormatter}
            dataToolConfig={dataToolConfig}
            selectedDataTool={selectedDataTool}
            selectedDataCollection={selectedDataCollection}
            maxValuesSelectedFilter={maxValuesSelectedFilter}
            theme={theme}
            refinementFilters={refinementFilters}
            dataResponse={dataResponse}
        />
    </>
);

export default LineChartSection;
